import React, { useContext } from 'react';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
import DeleteSharedExperienceModal from '../../components/deleteSharedExperienceModal';

export default function SharedExperienceAsideEditMenu() {
  const {
    sharedExperience,
    rights,
  } = useContext(SharedExperiencesContext);
  const modalDelete = useDisclosure();
  
  return (
    <>
      {rights && (
        <Menu>
          {({ isOpen }) => (
            <>
              <MenuButton
                isActive={isOpen}
                as={IconButton}
                icon={<MdMoreHoriz />}
                variant="greenOutline"
              />
              <MenuList fontSize={"14px"}>
                {rights.can_delete && (
                  <MenuItem onClick={() => {
                    modalDelete.onOpen();
                  }}>
                    <Icon
                      as={MdOutlineDelete}
                      color='text.medium.red'
                      boxSize={'14px'}
                      mr={2}
                    />
                    <Text color='text.medium.red'>Delete</Text>
                    <DeleteSharedExperienceModal disclosure={modalDelete} />
                  </MenuItem>
                )}
              </MenuList>
            </>
          )}
        </Menu>
      )}
    </>
  )
} 